export const HOME_DATA = {
    currentDog: {
        id: '1',
        name: 'Buddy',
        image: 'https://images.unsplash.com/photo-1517849845537-4d257902454a',
        breed: 'Golden Retriever',
        weight: 28.5,
        birthDate: '2022-08-15', // ~2 anos e 3 meses
    },
    dogs: [
        {
            id: '1',
            name: 'Buddy',
            image: 'https://images.unsplash.com/photo-1517849845537-4d257902454a',
            breed: 'Golden Retriever',
            weight: 28.5,
            birthDate: '2022-08-15', // ~2 anos e 3 meses
        },
        {
            id: '2',
            name: 'Max',
            image: 'https://images.unsplash.com/photo-1537151608828-ea2b11777ee8',
            breed: 'Labrador',
            weight: 32.0,
            birthDate: '2021-03-20', // ~3 anos e 8 meses
        },
        {
            id: '3',
            name: 'Luna',
            image: 'https://images.unsplash.com/photo-1583511655857-d19b40a7a54e',
            breed: 'Pug',
            weight: 8.5,
            birthDate: '2024-04-10', // ~7 meses
        }
    ],
    activeWalk: null, // or object if active
    location: 'home' as 'home' | 'street' | 'daycare',
    behaviorStats: {
        grimaceScale: 0, // 0-10
        label: 'Sem dor',
    },
    reminders: [
        {
            id: '1',
            title: 'Remédio de Pulga',
            date: new Date(new Date().setDate(new Date().getDate() + 2)), // 2 days from now
            type: 'medication' as const,
        },
        {
            id: '2',
            title: 'Vacina da Raiva',
            date: new Date(new Date().setDate(new Date().getDate() + 15)), // 15 days from now
            type: 'vaccine' as const,
        },
    ],
};
